module.exports = "/images/bg_02.png?22d8aec2133429ce95c3ffd7bf0662af";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/images/bg_02.png
// module id = 52sd
// module chunks = 0